import { BottomSheetBackdrop } from '@gorhom/bottom-sheet'
import React from 'react'
import { StyleSheet, useWindowDimensions } from 'react-native'

export const BottomSheetModalBackdrop = () => {
  const dimensions = useWindowDimensions()
  const computedStyles = StyleSheet.create({
    backdrop: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: dimensions.width,
      height: dimensions.height,
      backgroundColor: 'rgba(0,0,0,.33)',
    },
  })

  return (
    <BottomSheetBackdrop
      appearsOnIndex={0}
      disappearsOnIndex={-1}
      animatedIndex={{
        value: 0,
      }}
      animatedPosition={{
        value: 0,
      }}
      pressBehavior='close'
      style={computedStyles.backdrop}
    />
  )
}
